import { render, staticRenderFns } from "./individualCheckoff.vue?vue&type=template&id=bfc392e4&"
import script from "./individualCheckoff.vue?vue&type=script&lang=js&"
export * from "./individualCheckoff.vue?vue&type=script&lang=js&"
import style0 from "./individualCheckoff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports